export const styles = theme => ({
    loggingIn: {
        margin: 25,
        display: "flex",
        "& h4": {
            marginLeft: 16,
        }
    },
    loggedOut: {
        margin: 25,
    }

});